import React, { useState, useEffect } from 'react';
import api from '../api';

// Read-only IT health dashboard content (embedded in the portal as "Campus Overview")
export default function PrincipalContent() {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/master/stats').then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const t = stats?.tasks  || {};
  const a = stats?.assets || {};
  const newTickets = t['Pending'] || 0;
  const pending    = (t['Assigned'] || 0) + (t['In Progress'] || 0) + (t['Needs Discussion'] || 0) + (t['Discussed'] || 0);
  const closed     = (t['Completed'] || 0) + (t['Closed'] || 0);
  const assetTotal = ['Good','Fair','Needs Repair','Faulty'].reduce((s,k) => s + (a[k]||0), 0);

  const Card = ({ label, value, color, sub }) => (
    <div className="card" style={{ textAlign:'center', padding:'22px 16px' }}>
      <div style={{ fontSize:32, fontWeight:700, color: color || 'var(--text)' }}>{value}</div>
      <div style={{ fontSize:13, color:'var(--text2)', marginTop:4 }}>{label}</div>
      {sub && <div style={{ fontSize:11, color:'var(--text3)', marginTop:2 }}>{sub}</div>}
    </div>
  );

  const CONDS = [
    { k:'Good',         c:'var(--green)'  },
    { k:'Fair',         c:'var(--amber)'  },
    { k:'Needs Repair', c:'var(--orange)' },
    { k:'Faulty',       c:'var(--red)'    },
  ];

  return (
    <div style={{ maxWidth:960 }}>
      <h2 style={{ fontSize:18, fontWeight:600, marginBottom:4 }}>🏛 Campus IT Health</h2>
      <p style={{ fontSize:13, color:'var(--text2)', marginBottom:18 }}>Read-only view · live data from the IT Portal.</p>
      <div>
        {loading ? <div style={{ padding:60, textAlign:'center', color:'var(--text2)' }}>Loading…</div> : !stats ? (
          <div className="empty-state"><h3>Could not load metrics</h3></div>
        ) : (
          <>
            {/* Complaint / task metrics */}
            <div style={{ fontSize:12, fontWeight:600, color:'var(--text2)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>
              Complaints & Tasks
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:14, marginBottom:28 }}>
              <Card label="New Tickets" value={newTickets} color="var(--accent)" sub="awaiting assignment" />
              <Card label="Pending" value={pending} color={pending > 0 ? 'var(--amber)' : 'var(--green)'} sub="being worked on" />
              <Card label="Closed" value={closed} color="var(--green)" sub="completed & closed" />
              <Card label="Resolved This Week" value={stats.resolved_week ?? 0} />
            </div>

            {/* Asset health */}
            <div style={{ fontSize:12, fontWeight:600, color:'var(--text2)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>
              Asset Health {assetTotal > 0 && <span style={{ fontWeight:400 }}>· {assetTotal} assets</span>}
            </div>
            <div className="card" style={{ marginBottom:28 }}>
              {assetTotal === 0 ? (
                <div style={{ color:'var(--text2)', fontSize:13 }}>No assets recorded yet.</div>
              ) : (
                <>
                  {/* Stacked bar */}
                  <div style={{ display:'flex', height:14, borderRadius:7, overflow:'hidden', marginBottom:14 }}>
                    {CONDS.map(({ k, c }) => (a[k]||0) > 0 && (
                      <div key={k} style={{ width:`${(a[k]/assetTotal)*100}%`, background:c }} title={`${k}: ${a[k]}`} />
                    ))}
                  </div>
                  <div style={{ display:'flex', gap:20, flexWrap:'wrap' }}>
                    {CONDS.map(({ k, c }) => (
                      <span key={k} style={{ fontSize:13 }}>
                        <span style={{ display:'inline-block', width:10, height:10, borderRadius:3, background:c, marginRight:6 }} />
                        {k}: <strong>{a[k] || 0}</strong>
                      </span>
                    ))}
                  </div>
                </>
              )}
            </div>

            {/* Other registers */}
            <div style={{ fontSize:12, fontWeight:600, color:'var(--text2)', textTransform:'uppercase', letterSpacing:'0.05em', marginBottom:10 }}>
              Registers
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:14 }}>
              <Card label="Network Device Configs" value={stats.configs ?? 0} />
              <Card label="Scrapped Equipment" value={stats.scrap ?? 0} />
            </div>

            <p style={{ fontSize:11, color:'var(--text3)', marginTop:28, textAlign:'center' }}>
              Live data from the IT Portal — no manual reports required. For details, contact the IT department.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
